export default function isSimpleProduct(product) {
  return Boolean(product?.defaultVariant);
}
